// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Me29","select":"styles_select__m0WTb"};